module.exports = __webpack_public_path__ + "img/به-انتخاب-طراح.fe970bbb.png";